export default __webpack_public_path__ + "static/logo-2ddddd81baf4d25430bd3af1f9635e19.svg";